import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const slackThreadMessagePayloadSchema = z
    .object({
        type: z.literal('slack_thread_message').optional(),
        slack_team_id: z.string(),
        slack_channel_id: z.string(),
        slack_thread_ts: z.string(),
        slack_user_id: z.string(),
        slack_user_display_name: z.string().nullable().optional(),
        text: z.string(),
    })
    .strip();

export const slackThreadMessageDefinitions = {
    slack_thread_message: defineInvisible('slack_thread_message', {
        disposition: 'invisible',
        schema: slackThreadMessagePayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
    }),
} as const;

export const slackThreadMessageContractFixtures = {
    valid: {
        type: 'slack_thread_message',
        slack_team_id: 'team-1',
        slack_channel_id: 'channel-1',
        slack_thread_ts: '1724846400.000000',
        slack_user_id: 'user-1',
        slack_user_display_name: 'Internal staff name',
        text: 'Internal Slack message',
    },
    malformed: {
        type: 'slack_thread_message',
        slack_team_id: 'team-1',
        slack_channel_id: 'channel-1',
        slack_thread_ts: '1724846400.000000',
        slack_user_id: 'user-1',
        text: 7,
    },
} as const;
